import { gql } from '@apollo/client'
import { ADMIN_AUDIT_FRAGMENT } from '../fragments'

export const GET_ADMIN_PORTAL_AUDITS = gql`
  query GetAdminPortalAudits($input: AdminPortalAuditsInput) {
    adminPortalAudits(input: $input) {
      results {
        ...AdminAudit
      }
      hasMore
      count
    }
  }
  ${ADMIN_AUDIT_FRAGMENT}
`
